import Vue from 'vue'
import LocalizationEN from './en.js';
import LocalizationDE from './de.js';

/**
 * i18n
 */
import VueI18n from 'vue-i18n'

const langConfig = {
  locale: 'en',
  messages: {
    en: LocalizationEN,
    de: LocalizationDE
  }
};
Vue.use(VueI18n);

// Create VueI18n instance with options
export const i18n = new VueI18n(langConfig)